module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-1040.8a52e3dd.jpg";